/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Location/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2LocationPin from 'DesignSystem/Svgs/Tysiav2LocationPin/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Location({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/Locations/Content/Location"
  
}) {
let locations0NameValueData = fromData.useDataValue({ viewPath,
context: 'locations',
path: '[0].name',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Location.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2LocationPin
  viewPath={`${viewPath}/Tysiav2LocationPin`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="regular"
 weight="medium"
 color={dtColorsNeutral900}
 marginLeft={dtSpaceXxs}
 data="locations.[0].name"
 text={locations0NameValueData}
/>
</div>
{children}
</React.Fragment>)
}